/* eslint-disable prettier/prettier */
export const teamsTemplateFamilies = [
  {
    semanticTemplateCatalogue: [
      {
        isActive: true,
        isSelectorSmall: false,
        modelSelectorColumns: 6,
        templateId: "crd-1c51bc52-ea39-41cf-beba-3dfb44f84744",
        templateName: "Card 1A",
        templatePreviewUrl: "templates/teams_01A.svg",
      },
      {
        isActive: true,
        isSelectorSmall: false,
        modelSelectorColumns: 6,
        templateId: "crd-e9e05ff3-3e6d-48ee-b411-eeb7e7224a60",
        templateName: "Card 1B",
        templatePreviewUrl: "templates/teams_01B.svg",
      },
      {
        isActive: true,
        isSelectorSmall: false,
        modelSelectorColumns: 6,
        templateId: "crd-3c08cdb8-877a-4d62-a292-71d0fe3b1e5c",
        templateName: "Card 2A",
        templatePreviewUrl: "templates/teams_02A.svg",
      },
      {
        isActive: true,
        isSelectorSmall: false,
        modelSelectorColumns: 6,
        templateId: "crd-ec2a2801-9b85-44fc-96ed-859ab148df49",
        templateName: "Card 2B",
        templatePreviewUrl: "templates/teams_02B.svg",
      },
    ],
    tFamilyId: "fam-038da0d7-6481-4368-b1f4-a692e34929d2",
    tFamilyName: "Family 1 Teams",
  },
  {
    semanticTemplateCatalogue: [
      {
        isActive: true,
        isSelectorSmall: false,
        modelSelectorColumns: 12,
        templateId: "crd-1f7a5ca6-3198-42bb-bc93-e77bcd1ddbed",
        templateName: "Card T1",
        templatePreviewUrl: "templates/teams_generic_Approfondimento_blu.png",
      },
      /*{
        isActive: true,
        isSelectorSmall: false,
        modelSelectorColumns: 6,
        templateId: "crd-348e4c31-6c53-4dc3-85cd-5fd7281975ce",
        templateName: "Card T1 gradient",
        templatePreviewUrl: "templates/teams_Approfondimento_gradient.png",
      },*/
      {
        isActive: true,
        isSelectorSmall: false,
        modelSelectorColumns: 12,
        templateId: "crd-9fe9a579-738c-4010-95cf-615e67dae582",
        templateName: "Card F1",
        templatePreviewUrl: "templates/teams_generic_Informazione_blu.png",
      },
    ],
    tFamilyId: "fam-44197fb8-7a0b-4079-a76f-25210e68db4e",
    tFamilyName: "Family 2 Teams",
  },
  {
    semanticTemplateCatalogue: [
      {
        isActive: true,
        isSelectorSmall: false,
        modelSelectorColumns: 6,
        templateId: "crd-70443292-2541-44df-8c3e-f4fab4dc53c2",
        templateName: "Approfondimento dark",
        templatePreviewUrl: "templates/Teams_Approfondimento_dark.png",
      },
      {
        isActive: true,
        isSelectorSmall: false,
        modelSelectorColumns: 6,
        templateId: "crd-7bdd0769c-b817-44eb-8bcd-ba129a5a47cc",
        templateName: "Approfondimento light",
        templatePreviewUrl: "templates/Teams_Approfondimento_light.png",
      },
      {
        isActive: true,
        isSelectorSmall: false,
        modelSelectorColumns: 6,
        templateId: "crd-48344bd1-8d43-4a6d-8c6c-e09e4ef73996",
        templateName: "Informazione dark",
        templatePreviewUrl: "templates/Teams_Informazione_dark.png",
      },
      {
        isActive: true,
        isSelectorSmall: false,
        modelSelectorColumns: 6,
        templateId: "crd-c73ef69e-ec22-4fb4-91f1-4d0aff0fb3ba",
        templateName: "Informazione light",
        templatePreviewUrl: "templates/Teams_Informazione_light.png",
      },
      {
        isActive: true,
        isSelectorSmall: false,
        modelSelectorColumns: 6,
        templateId: "crd-d53caadf-d6ef-4602-8296-9d0bb7c33c31",
        templateName: "Informazione Icona dark",
        templatePreviewUrl: "templates/Teams_Informazione_Icona_dark.png",
      },
      {
        isActive: true,
        isSelectorSmall: false,
        modelSelectorColumns: 6,
        templateId: "crd-690d9038-aa79-4ee2-a6fc-7db689f17199",
        templateName: "Informazione Icona light",
        templatePreviewUrl: "templates/Teams_Informazione_Icona_light.png",
      },
    ],
    tFamilyId: "fam-dc423757-effc-4510-ac5a-9c9f4c9ec268",
    tFamilyName: "Family easyPop",
  },
];
